import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import CollectionsPage from './pages/CollectionsPage';
import AnalyticsDashboardPage from './pages/AnalyticsDashboardPage';
import SystemActivityPage from './pages/SystemActivityPage';
import MainLayout from './components/MainLayout';
import { ConfigProvider, theme } from 'antd';
import { colors } from './theme/themeConfig';
import './App.css';
import DatasetListPage from './pages/DatasetListPage';
import DatasetEditorPage from './pages/DatasetEditorPage';
import ExternalDashboardsPage from './pages/ExternalDashboardsPage';
import ReportBuilderPage from './pages/ReportBuilderPage';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  return isAuthenticated ? <>{children}</> : <Navigate to="/" replace />;
};

function App() {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: colors.primary,
          borderRadius: 6,
          colorBgContainer: '#ffffff',
          colorText: 'rgba(0, 0, 0, 0.88)',
          colorTextSecondary: 'rgba(0, 0, 0, 0.45)',
          controlHeight: 44,
          fontSize: 14,
        },
      }}
    >
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LoginPage />} />

            {/* Protected Routes wrapped in MainLayout */}
            <Route
              path="/:workspaceId"
              element={
                <PrivateRoute>
                  <MainLayout />
                </PrivateRoute>
              }
            >
              <Route path="home" element={<HomePage />} />
              <Route path="collection/:collectionId" element={<CollectionsPage />} />
              <Route path="analytics/:dashboardId" element={<AnalyticsDashboardPage />} />
              <Route path="system-activity" element={<SystemActivityPage />} />
              <Route path="external-dashboards" element={<ExternalDashboardsPage />} />

              {/* Dataset Routes */}
              <Route path="dataset" element={<DatasetListPage />} />
              <Route path="dataset/new" element={<DatasetEditorPage />} />
              <Route path="dataset/:id" element={<DatasetEditorPage />} />
              <Route path="visualise/report" element={<ReportBuilderPage />} />
              <Route path="visualise/report/:datasetId" element={<ReportBuilderPage />} />

              {/* Fallback redirect */}
              <Route index element={<Navigate to="home" replace />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </ConfigProvider>
  );
}

export default App;
